import { categoryConstants } from '../constants';
import { categoryService } from '../../services';

export const categoryActions = {
  getCategories,
  createCategory,
  getCategory,
  updateCategory,
  deleteCategory
}

/*
ACTION: Categories List
*/
function getCategories(type = '') {
  return dispatch => {
    dispatch(request());
    return categoryService.getCategoriesResponse(type)
      .then(
        response => {
          dispatch(success(response.data.body.categories));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: categoryConstants.GETALL_REQUEST } }
  function success(items) { return { type: categoryConstants.GETALL_SUCCESS, items } }
  function failure(error) { return { type: categoryConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Create Category
*/
function createCategory(addToast, formData, type = '') {
  return dispatch => {
    dispatch(request());
    return categoryService.createCategory(formData, type)
      .then(
        response => {
          addToast('دسته‌بندی با موفقیت اضافه شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(response.data.body.id));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: categoryConstants.CREATE_REQUEST } }
  function success(tokenID) { return { type: categoryConstants.CREATE_SUCCESS, tokenID } }
  function failure(error) { return { type: categoryConstants.CREATE_FAILURE, error } }
}

/*
ACTION: Get Category
*/
function getCategory(categoryID, type = '') {
  return dispatch => {
    dispatch(request());
    return categoryService.getCategory(categoryID, type)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: categoryConstants.GET_REQUEST } }
  function success(item) { return { type: categoryConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: categoryConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Category
*/
function updateCategory(addToast, formData, type = '') {
  return dispatch => {
    dispatch(request());
    return categoryService.updateCategory(formData, type)
      .then(
        response => {
          addToast('دسته‌بندی با موفقیت بروزرسانی شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(formData.id));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: categoryConstants.UPDATE_REQUEST } }
  function success(tokenID) { return { type: categoryConstants.UPDATE_SUCCESS, tokenID } }
  function failure(error) { return { type: categoryConstants.UPDATE_FAILURE, error } }
}

/*
ACTION: Delete Category
*/
function deleteCategory(addToast, categoryID, type = '') {
  return dispatch => {
    dispatch(request());
    return categoryService.deleteCategory(categoryID, type)
      .then(
        response => {
          addToast('دسته‌بندی مورد نظر حذف شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(categoryID));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: categoryConstants.DELETE_REQUEST } }
  function success(tokenID) { return { type: categoryConstants.DELETE_SUCCESS, tokenID } }
  function failure(error) { return { type: categoryConstants.DELETE_FAILURE, error } }
}